import { jsx as _jsx } from "jsx-dom/jsx-runtime";
/** @jsxImportSource jsx-dom */
import { select } from "@fruugo/utilities";
import { addItemToCartRequest } from "../api";
import { openModal } from "../components/modal/Modal";
import { LoadingModalContent } from "../components/modal/LoadingModalContent";
import { ProductAddedToCartModalContent } from "../components/modal/ProductAddedToCartModalContent";
import { sendAddToCartEvent } from "../analytics/google-analytics";
import { sendFacebookPixelEvent } from "../analytics/facebook-pixel";
import { FruugoAnalyticsAddToCartEvent } from "../analytics/fruugo-analytics/FruugoAnalyticsAddtoCartEvent";
import { i18n } from "../i18n";
import { ModalType } from "../components/modal/types";
import { sendRTBAddToCartEvent } from "../analytics/rtb-house";
import { sendPinterestAddToCartEvent } from "../analytics/pinterest";
import { sendTikTokAddToCartEvent } from "../analytics/tiktok";
var cheapestShippingMethod = window.cheapestShippingMethod;
export function handleAddToCart(skuId, quantity) {
    var _a = openModal(ModalType.ProductAddedToCart, _jsx(LoadingModalContent, {}), {
        ariaLabel: i18n("common.loading"),
    }), _ = _a[0], updateModal = _a[1];
    addItemToCartRequest(skuId, quantity)
        .then(function (response) {
        var cartValid = response.cartValid, success = response.success, checkoutUrl = response.checkoutUrl, message = response.message;
        var skuInfo = window.skuInfo, productId = window.productId, retailerInformation = window.retailerInformation;
        var title = skuInfo.title, description = skuInfo.description;
        var _a = skuInfo.price, numericTotalInclTax = _a.numericTotalInclTax, currencyCode = _a.currencyCode, numericTotalInclTaxAfterDiscount = _a.numericTotalInclTaxAfterDiscount;
        updateModal(_jsx(ProductAddedToCartModalContent, { cartValid: cartValid, success: success, checkoutUrl: checkoutUrl, message: message, quantity: quantity }), {
            ariaLabel: i18n("product.modal.addedtocart"),
            ariaDescribedby: "added-to-cart-aria-description",
        });
        if (response.success === true) {
            window.totalCartItems = response.totalItemsInCart;
            var cartItems = select(".js-cart-counter");
            if (cartItems) {
                cartItems.classList.remove("d-none");
                cartItems.innerText = response.totalItemsInCart.toString();
            }
        }
        sendAddToCartEvent(skuInfo, quantity, {
            buy_now: false,
        }, {
            sku_id: skuInfo.id,
            retailer_id: retailerInformation.id,
            retailer_name: retailerInformation.name,
            retailer_country: retailerInformation.country,
            days_to_dispatch: skuInfo.shipping.daysToDispatch,
            days_to_deliver: cheapestShippingMethod === null || cheapestShippingMethod === void 0 ? void 0 : cheapestShippingMethod.daysToDelivery,
            shipping_cost: cheapestShippingMethod === null || cheapestShippingMethod === void 0 ? void 0 : cheapestShippingMethod.numericPrice,
            free_shipping: cheapestShippingMethod === null || cheapestShippingMethod === void 0 ? void 0 : cheapestShippingMethod.free,
            item_available: skuInfo.sellable,
        });
        sendFacebookPixelEvent("AddToCart", {
            value: skuInfo.price.numericTotalInclTaxAfterDiscount &&
                skuInfo.price.numericTotalInclTax,
            currency: skuInfo.price.currencyCode,
            contents: [{ id: skuInfo.productId, quantity: quantity }],
            content_type: "product",
        });
        var event = new FruugoAnalyticsAddToCartEvent(productId);
        event.send();
        sendRTBAddToCartEvent(productId);
        sendPinterestAddToCartEvent(productId, title, numericTotalInclTaxAfterDiscount !== null && numericTotalInclTaxAfterDiscount !== void 0 ? numericTotalInclTaxAfterDiscount : numericTotalInclTax, quantity, currencyCode);
        sendTikTokAddToCartEvent(productId, title, currencyCode, description, quantity, numericTotalInclTaxAfterDiscount !== null && numericTotalInclTaxAfterDiscount !== void 0 ? numericTotalInclTaxAfterDiscount : numericTotalInclTax);
    })
        .catch(function () {
        updateModal(_jsx(ProductAddedToCartModalContent, { cartValid: false, success: false, message: i18n("cart.generic.error") }), {
            ariaLabel: i18n("product.modal.addedtocart"),
            ariaDescribedby: "added-to-cart-aria-description",
        });
    });
}
